var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademiesAcountIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#014337"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4034_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.08333 11.9999C10.3667 11.9999 11.4167 10.9499 11.4167 9.66659C11.4167 8.38325 10.3667 7.33325 9.08333 7.33325C7.8 7.33325 6.75 8.38325 6.75 9.66659C6.75 10.9499 7.8 11.9999 9.08333 11.9999ZM11.4167 16.6666V13.5749C10.775 13.3416 9.95833 13.1666 9.08333 13.1666C6.80833 13.1666 5 14.2166 5 15.4999V16.6666H11.4167ZM13.75 7.33325C13.1083 7.33325 12.5833 7.85825 12.5833 8.49992V15.4999C12.5833 16.1416 13.1083 16.6666 13.75 16.6666H17.8333C18.475 16.6666 19 16.1416 19 15.4999V8.49992C19 7.85825 18.475 7.33325 17.8333 7.33325H13.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4034_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademiesAcountIcons);
export default __webpack_public_path__ + "static/media/academies-acount-icons.a67dfc28f9f872974f7ba41eb480ee8c.svg";
export { ForwardRef as ReactComponent };